module.exports = __webpack_public_path__ + "static/media/logis2_10.0b9c5a85.png";